import { apiAxiosCMS } from 'services/api';
import { LogoProps } from 'types/LogoProps';

interface RespReqProps {
	isSuccess: boolean;
	logoSaved: LogoProps | null;
}

export async function addLogoReq(
	form: LogoProps,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	handleNotify: any
) {
	const respReq: RespReqProps = {
		isSuccess: false,
		logoSaved: null
	};

	setMessage('Salvando logo');
	setIsLoad(true);

	const payload: any = { ...form };

	delete payload.id;

	await apiAxiosCMS
		.post('logo', payload)
		.then((res) => {
			respReq.isSuccess = true;
			respReq.logoSaved = res.data;
			handleNotify('Logo adicionado com sucesso.', 'success');
		})
		.catch((error) => {
			respReq.isSuccess = false;
			respReq.logoSaved = null;
			handleNotify('Erro ao adicionar logo.', 'error');
			console.error('✌️error --->', error);
		});

	setIsLoad(false);

	return respReq;
}

export async function editLogoReq(
	logoToEdit: LogoProps,
	form: LogoProps,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	handleNotify: any
) {
	const respReq = {
		isSuccess: false
	};

	setMessage('Editando logo');
	setIsLoad(true);

	const payload: any = { ...form };

	delete payload.id;

	await apiAxiosCMS
		.patch(`/logo/${logoToEdit.id}`, payload)
		.then(() => {
			respReq.isSuccess = true;
			handleNotify('Logo adicionado com sucesso.', 'success');
		})
		.catch((error) => {
			respReq.isSuccess = false;
			handleNotify('Erro ao adicionar logo.', 'error');
			console.error('✌️error --->', error);
		});

	setIsLoad(false);

	return respReq;
}
